export function _<T extends string | string[]>(key: T): T {
    return key;
}
